/**
 * Generated by orval 🍺
 * Do not edit manually.
 * IST.Connect | v1
 * REST API backing the IST Connect web frontend. Provides endpoints to manage plugin configurations and inspect task execution results, logs, and dashboard data.
 * OpenAPI spec version: 1.0.0
 */
import type { UISettings } from "../model";

import { customFetch } from "../../customFetcher";

export const getGetUiOptionsUrl = () => {
	return `/istconnect-service-api/uioptions`;
};

/**
 * @summary Get the UI options
 */
export const getUiOptions = async (options?: Parameters<typeof customFetch>[1]): Promise<UISettings> => {
	return customFetch<UISettings>(getGetUiOptionsUrl(), {
		...options,
		method: "GET",
	});
};
